var en = {
	services: {
		storybook: {
			label: "Storybook"
		},
		softphone: {
			label: "Soft Phone"
		},
		aiassist: {
			label: "AI Assist"
		},
		problem_helper: {
			label: "Report a problem"
		}
	},
	components: {
		emojipicker: {
			label: "Emoji Picker"
		}
	},
	notifications: {
		Notifications: "Notifications",
		"Trail events": "Trail events",
		"Mark all as read": "Mark all as read",
		"No notifications yet": "No notifications yet",
		"There is no new notifications for you": "There is no new notifications for you."
	}
};
var DEFAULT_TRANSLATIONS = {
	en: en
};

function useI18n() {
  return {
    initializeI18n() {
      const i18n = this.$i18n;
      i18n.mergeLocaleMessage(i18n.locale, DEFAULT_TRANSLATIONS.en);
    },
    mergeLocaleMessages(messages) {
      const i18n = this.$i18n;
      for (const locale in messages) {
        i18n.mergeLocaleMessage(locale, messages[locale]);
      }
    },
    translate(str) {
      const i18n = this.$i18n;
      return i18n.t(str);
    }
  };
}

export { useI18n as u };
